module.exports = __webpack_public_path__ + "static/media/delete.f86c5ef2.png";